const transformFocalPoint = (focalPoint) => {
  const x = focalPoint.split(',')[1] ? parseFloat(focalPoint.split(',')[0]) : 0.5
  const y = focalPoint.split(',')[1] ? parseFloat(focalPoint.split(',')[1]) : 0.5
  return {
    x: x,
    y: y,
    string: `${x * 100}% ${y * 100}%`
  }
}

export default transformFocalPoint